module.exports = __webpack_public_path__ + "img/1gCmHXUz4j0j6U3y41fpnPfSSERlCsf92.ddcb8f96.jpg";